export  const formatWatchTime = (time: string) => {
    const [hours, minutes] = time.split(':').map(Number);
    
    let formattedTime = '';

    if (hours > 0) {
        formattedTime += `${hours}h `;
    }

    if (minutes > 0) {
        formattedTime += `${minutes}min`;
    }

    return formattedTime.trim();
}